import { render } from "./SaveTimesheetAction.vue?vue&type=template&id=67555fa4"
import script from "./SaveTimesheetAction.vue?vue&type=script&lang=js"
export * from "./SaveTimesheetAction.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nisalatp/Projects/Herd/OrangeHRM/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__